import { makeResourceKeys } from 'requests/resources/makeResources/makeResourcesKeys';

export const keys = makeResourceKeys('fileUploads');
